import React from 'react'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import {withStyles} from '@material-ui/core/styles'
import {Slide, Typography, Grid } from '@material-ui/core'
import Email from '@material-ui/icons/Email'
import MobileIcon from '@material-ui/icons/StayCurrentPortrait'
import Call from '@material-ui/icons/Call'
import CloseIcon from '@material-ui/icons/Close'
import { getDateFormated } from '../../js/helper'
import {Title} from './MessagingInbox'

const styles = theme => ({
    paper: {
        padding: theme.spacing.unit*2,
        //border: `1px solid ${theme.palette.primary.dark}`,
        boxShadow: `1px 1px 1px 1px ${theme.palette.primary.main}`,
        //backgroundColor: '#E1F5FE',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing.unit,
            }
    },
    header: {
        position: 'relative',
        marginBottom: theme.spacing.unit*2
    },
    headerTypo: {
        lineHeight: '1.4em'
    }, headerItems: {
        marginTop: theme.spacing.unit,

    },
    closeIcon: {
        color: theme.palette.primary.dark,
        position: 'absolute',
        top: -4,
        right: -4,
        width: '1.35em',
        height: '1.35   em',
        cursor: 'pointer',
        '&:hover':{
            backgroundColor: '#E3F2FD',
            borderRadius: '0.7em'

        }
        
    },
    messageBody : {
        marginBottom: '8px'
    },
    requesterGridRow : {
        padding: '2px',
        borderBottom: '1px solid white'
       
    },
    link: {
        textDecoration: 'none'
    },
    requesterData: {
        backgroundColor: '#f1f1f1',
        color: 'black', //'#303030',
        maxWidth: '700px',
        padding: '8px',
        borderRadius: '8px'
    },
    buttons: {
        marginRight: theme.spacing.unit,
    },
    messageFooter: {
        padding: theme.spacing.unit *2,
    }

})

const InboxItemDetails = (props) => {
    const { classes, message, functions, requesterData, event } = props
    const renderMailHeader = [
        <div> Erhalten: {getDateFormated(message.timeStamp, 'withTime')}</div>,
        <div> Absender: {message.sender}</div>,
        <div style={{fontWeight: 'bold'}}>Betreff: {message.data.eventTask}</div>
    ]
    return (
        <Slide in={true} >
            <Paper className={classes.paper} autoFocus>
                <div className={classes.header}>
                    <Title style={{borderBottom: '2px solid #3f51b5'}} title='Neue Nachricht' />
                    <CloseIcon 
                        className={classes.closeIcon}
                        onClick={functions.closeDetails}
                    />
                    <div className={classes.headerItems}>
                        {renderMailHeader.map((headerItem, index) =>
                            <Typography className={classes.headerTypo} key={index} variant='subheading'>
                                {headerItem}
                            </Typography>
                        )}
                    </div>
                </div>
                <div className={classes.messageBody}>
                    <Typography className={classes.messagesBodyTypo} variant='subheading'>
                        {message.body}
                    </Typography>
                </div>
                <div className={classes.requesterData} >
                    <Typography 
                        color='inherit'
                        variant='subheading'
                        children={
                            <RequesterData
                                classes={classes}
                                message={message}
                                requesterData={requesterData}
                                event={event}
                            />
                        }
                    />
                </div>
                <div className={classes.messageFooter} >
                    <Button className={classes.buttons} onClick={functions.confirmEvent} variant='contained' size='small' style={{backgroundColor: 'green', color:'white'}}>Annehmen</Button>
                    <Button className={classes.buttons} onClick={functions.rejectEvent} variant='contained' size='small' color='secondary'>Ablehnen</Button>
                    <Button className={classes.buttons} onClick={functions.closeDetails} variant='contained' size='small' color='primary'>Schließen</Button>
                    
                </div>
            </Paper>
        </Slide>
    )
}

export default withStyles(styles)(InboxItemDetails)


const RequesterData = ({ classes, message, requesterData, event }) =>  {
  
    return ( <div className={classes.requesterBox}>
        <Grid id='requesterDetails' container >
            <Grid className={classes.requesterGridRow} item xs={12} container>
                <Grid item sm={4} children='Termin:' />
                <Grid
                    style={event.event.timeRange==='onDate' ? {color: 'red'} : null}
                    className={classes.requesterContent}
                    item xs={12} sm={8}
                    children={event.event.timeRange==='onDate' ? 'An einem bestimmten Datum' : 'Nach vereinbarung bis'} 
                    />
            </Grid>
            <Grid className={classes.requesterGridRow} item xs={12} container>
                <Grid item sm={4} children='Datum:' />
                <Grid 
                    className={classes.requesterContent}
                    item xs={12} sm={8}
                    children={getDateFormated(message.data.eventDate, 'normal')} 
                    />
            </Grid>
            <Grid className={classes.requesterGridRow} item xs={12} container>
                <Grid item sm={4} children='Uhrzeit:' />
                <Grid 
                    style={event.event.time==='Nach Vereinbarung' ? null : {color: "red", fontWeight: 'bold'}}
                    className={classes.requesterContent}
                    item xs={12} sm={8}
                    children={event.event.time==='Nach Vereinbarung' || typeof(event.event.time)==='undefined' ? 'Nach Vereinbarung' : 'Um ' + event.event.time + ' Uhr'} 
                    />
            </Grid>
            <Grid className={classes.requesterGridRow}  item xs={12} container >
                <Grid item sm={4} children='Hilfesuchender:' />      
                <Grid 
                    className={classes.requesterContent}
                    item xs={12} sm={8} 
                    children={requesterData.name}
                /> 
            </Grid>
            <Grid className={classes.requesterGridRow}  item xs={12} container >
                <Grid item sm={4} children='Hilfegesuch:' />
                <Grid 
                    className={classes.requesterContent}
                    item xs={12} sm={8} 
                    children={message.data.eventTask}
                />
            </Grid>
            {event.event.pkw!=='' 
                ?   <Grid className={classes.requesterGridRow}  item xs={12} container >
                        <Grid item sm={4} children='Beförderung:' />
                        <Grid 
                            style={{color: 'red'}}
                            className={classes.requesterContent}
                            item xs={12} sm={8} 
                            children={'PKW erforderlich!'}
                            />
                    </Grid>
                :   null
            }
            <Grid className={classes.requesterGridRow}  item xs={12} container >
                <Grid item sm={4} children='Straße:' />
                <Grid
                    className={classes.requesterContent}
                    item xs={12} sm={8}
                    children={requesterData.strasse}
                />    
            </Grid>
            <Grid className={classes.requesterGridRow}  item xs={12} container >
                <Grid item sm={4} children='Ort:' />
                <Grid 
                    className={classes.requesterContent}
                    item xs={12} sm={8}
                    children={requesterData.ort}
                />   
            </Grid>
            <Grid className={classes.requesterGridRow}  item xs={12} container >
                <Grid item sm={4} children='Telefon:' />
                <Grid
                    className={classes.requesterContent} 
                    item xs={12} sm={8} 
                > 
                    <a className={classes.link}href={`tel:${requesterData.telefon}`} >
                    <Call className={classes.icon} color='primary' /> 
                    {requesterData.telefon}
                    </a>
                </Grid> 
            </Grid>
            <Grid className={classes.requesterGridRow}  item xs={12} container >
                <Grid item sm={4} children='Mobil:' />
                <Grid
                    className={classes.requesterContent} 
                    item xs={12} sm={8} 
                > 
                    {requesterData.moblie
                        ? <a className={classes.link} href={`tel:${requesterData.mobil}`} >
                            <MobileIcon className={classes.icon} color='primary' /> 
                                {requesterData.mobil}
                          </a>
                        : <span><MobileIcon className={classes.icon} color='primary' />Nicht vorhanden</span>}
                </Grid> 
            </Grid>
            <Grid className={classes.requesterGridRow}  item xs={12} container>
                <Grid item sm={4} children='Email:' />
                <Grid 
                    className={classes.requesterContent}
                    item xs={12} sm={8}
                >
                    <a className={classes.link} href={`mailto: ${requesterData.email}`}>
                        <Email className={classes.icon} color='primary' />
                        {requesterData.email}
                    </a>
                </Grid>
            </Grid>
          
        </Grid>
    </div>)}


// WEBPACK FOOTER //
// ./src/Components/MessagingCenter/InboxItemDetails.js